import { render, staticRenderFns } from "./BannerComponent.vue?vue&type=template&id=202b2a16&scoped=true"
import script from "./BannerComponent.vue?vue&type=script&lang=js"
export * from "./BannerComponent.vue?vue&type=script&lang=js"
import style0 from "./BannerComponent.vue?vue&type=style&index=0&id=202b2a16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202b2a16",
  null
  
)

export default component.exports